/** @jsx jsx */

import React, {
  Fragment as _,
  useLayoutEffect,
  useEffect,
  useRef,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import isIE from 'services/isIE';
import onScrollEnds from 'services/onScrollEnds';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const Option = ({ option, isDragging }) => {
  const { id, children } = option;

  const context = useContext<any>(interactionContext);

  const optionContainer = useRef<any>(null);

  const {
    panelBackground = lPink,
    panelBackgroundDragging = lGrey0,
    textColorDragging = '#fff',
  } = context.props;

  useLayoutEffect(() => {
    // remove the chameleon-text class
    // so only responds to local color
    const chameleonText = optionContainer.current.querySelector(
      '.chameleon-text'
    );
    chameleonText && chameleonText.classList.remove('chameleon-text');
  });

  useEffect(() => {
    if (!isIE() || !optionContainer.current) {
      return;
    }
    //
    let tick;

    const onResize = () => {
      const content = optionContainer.current.firstElementChild;

      clearInterval(tick);

      tick = setInterval(() => {
        if (content.scrollHeight === 0) {
          return;
        }

        if (
          optionContainer.current.scrollHeight ===
          content.scrollHeight + 10
        ) {
          clearInterval(tick);
        }

        optionContainer.current.style.height = `${content.scrollHeight + 10}px`;
      }, 1000 / 60);
    };

    onScrollEnds(onResize);
    addEventListener('resize', onResize);

    onResize();

    return () => {
      removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div
      ref={optionContainer}
      id={`sortation-option-${id}`}
      className="sortation-option"
      css={css`
        display: flex;
        align-items: center;

        width: 100%;
        min-height: 55px;
        background: ${isDragging ? panelBackgroundDragging : panelBackground};
        margin: 5px 0;
        padding: 5px 10px;
        border-radius: 5px;
        color: ${isDragging ? textColorDragging : ''};
        transition: background 0.3s;

        //double up needed for editing. . .
        * div {
          color: ${isDragging ? textColorDragging : ''};
        }

        h1,
        h2,
        h3,
        p {
          margin: 0;
        }

        ${!window.dev() &&
        `
            user-select: none;
            // pointer-events: none;
        `}
      `}
    >
      {children}
    </div>
  );
};

export default Option;
